const CLIPBOARD_GUIDE_CHANNEL_SUFFIX = "_clipboard-guide";

export function isClipboardGuideChannel(channelUrl: string | undefined): boolean {
  return channelUrl?.endsWith(CLIPBOARD_GUIDE_CHANNEL_SUFFIX) ?? false;
}
